import { render, staticRenderFns } from "./ClassesItem.vue?vue&type=template&id=79a79db7&scoped=true&"
import script from "./ClassesItem.vue?vue&type=script&lang=js&"
export * from "./ClassesItem.vue?vue&type=script&lang=js&"
import style0 from "./ClassesItem.vue?vue&type=style&index=0&id=79a79db7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a79db7",
  null
  
)

export default component.exports